import React from 'react';
import { DatePicker, Checkbox, Select } from 'antd';
import { toast } from 'react-toastify';
import services from '../../services';
import { withRouter } from 'react-router-dom';
import FormleftNev from '../common/FormleftNev';
import EntityFilter from '../common/EntityFilter'
import queryString from 'query-string'
import FormNavbar from '../common/wizard_navbar';
import Lang from '../../lang'
import { Input } from '@progress/kendo-react-inputs';
const moment = require('moment');

const { Option } = Select

let apiFilters = {
    Filters: null,
    SortBy: 'ID',
    Page: 1,
    PageSize: 100,
    Filters: null,
    IsSortTypeDESC: false,
    IsPagination: false,
    
};

class EntityRuleFormComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            codEstatuto: [],
            codEntidade: 0,
            ruleList: [],
            entityList: [],
            codEntidadeName: '',
            id :'',
            error:null,
            isChecked: true,
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        //console.log("hihguyft",this.props)
        let parsed = queryString.parse(window.location.search)
        // if (this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id) {
        //     this.getEntidadeById(this.props.id.location.state.entidade_id)
        // }
        if(parsed.id){
            this.getEntidadeById(parsed.id)
        } 
        // else {
        //     this.getEntityList()
        // }
        this.getEstatutoList()
    }

    getEntityList = async () => {
        try {
            let data = {
                modulename: "parcel"
            }
            let res = await services.apiCall.requestApi('/Entity/GetAll', data, 'post');
            if (res) {
                this.setState({
                    entityList: res,
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    
    getEstatutoList = async () => {
        try {
            let res = await services.apiCall.requestApi('/Estatuto/GetAll', apiFilters, 'post');
            if (res) {
                this.setState({
                    ruleList: res,
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    createInputs(nevkey) {
        // let id = this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id
        let id = this.state.id
        let inputs = this.props.InputFieldsAll[nevkey].map((row, i) => {
            switch (row.type) {
                case "dropdown":
                    return (
                        <div className="col-md-12">
                            <div className="input-box active-grey mt-3">
                                <Select
                                    onChange={this.handleSelect}
                                    mode="multiple"
                                    showSearch
                                    style={{ width: "100%" }}
                                    placeholder={"Selecionar Estatuto"}
                                    optionFilterProp='children'
                                    value={this.state.codEstatuto}
                                >
                                    {
                                        this.state.ruleList.map((_r, i) => (
                                            <Option key={i} value={_r.codEstatuto}>{_r.description}</Option>
                                        ))
                                    }
                                </Select>
                            </div>
                        </div>
                    )
                    break;
                default:
                    if (id) {
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey">
                                    <Input
                                        readOnly
                                        style={{ width: "100%" }}
                                        className="input-1"
                                        label="Nome da Entidade"
                                        value={this.state.codEntidadeName}
                                    />
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div className="col-md-12">
                                <div className="input-box active-grey mt-3">
                                    {/* <Select
                                        onChange={this.handleEntitySelect}
                                        showSearch
                                        style={{ width: "100%" }}
                                        placeholder={"Selecionar Entidade"}
                                        optionFilterProp='children'
                                    >
                                        {
                                            this.state.entityList.map((_r, i) => (
                                                <Option key={i} value={_r.codEntidade}>{_r.nome}</Option>
                                            ))
                                        }
                                    </Select> */}
                                    <EntityFilter newPlaceHolder="Entidade" newClass="regras-rule-select" returnKey="codEntidade" getselectedEntity={(val)=>this.handleEntitySelect(val)} />
                                </div>
                            </div>
                        )
                    }
            }
        });
        return inputs
    }

    handleSelect = (value) => {
        //console.log("Select Estatuto",value)
        try {
            this.setState({
                codEstatuto: value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    handleEntitySelect = (value) => {
        try {
            this.setState({
                codEntidade: +value
            })
        } catch (error) {
            this.setState({error})
        }
    }

    createInputFields = () => {
        try {
            let InputFieldsdivs = Object.keys(this.props.InputFieldsAll).map((nevkey) => {
                return (<div className="bg-white middle p20" id={nevkey}>
                    <div className="head">
                        <h2> {Lang.langCheck.langRequest(`${nevkey}`)}</h2>
                        <p className="font-14">{/*"Lorem ipsum dolor sit amet, consetetur sadipscing elitrdiam"*/}</p>
                    </div>
                    <div className="row">
                        {this.createInputs(nevkey)}
                    </div>
                </div>
                )
            });
    
            return InputFieldsdivs;
        } catch (error) {
            this.setState({error})
        }
    }

    getEntidadeById = async (id) => {
        try {
            let resp = await services.apiCall.requestApi(`/BusEntidadeEstatuto/GetByID/${id}`, {}, 'get')
        //console.log(resp)
            if (resp) {
                this.setState({
                    codEntidadeName: resp.codEntidadeName,
                    codEstatuto: resp.codEstatuto,
                    codEntidade: resp.codEntidade,
                    id : id
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    handleSubmit = (e, backUrl) => {
        e.preventDefault();
        try {
            if(this.checkRequestData()){
                // if (this.props && this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id) {
                //     this.handleUpdateEntityEstatutoList(this.props.id.location.state.entidade_id, backUrl);
                // }
                if (this.state.id) {
                    this.handleUpdateEntityEstatutoList(this.state.id, backUrl);
                } else {
                    this.handleCreateEntityEstatutoList(backUrl);
                }
            }else{
                toast.error("Por favor preencha todos os campos")
            }
        } catch (error) {
            this.setState({error})
        }
    }

    handleUpdateEntityEstatutoList = async (id, backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res = await services.apiCall.requestApi(`/BusEntidadeEstatuto/Edit`, data, 'post')
            if (res) {
                if (backUrl) {
                    this.props.history.push({
                        pathname: backUrl,
                        state:{topBarMenu : this.props.topBarMenuOption}
                    })
                }
            }
        } catch (error) {
            this.setState({error})
        }
    }

    checkRequestData = () => {
        if(this.state.codEntidade == 0 || this.state.codEstatuto.length == 0){
            return false
        }else{
            return true
        }
    }

    handleCreateEntityEstatutoList = async (backUrl) => {
        try {
            let data = {
                codEntidade: this.state.codEntidade,
                codEstatuto: this.state.codEstatuto,
            }
            let res ;
            let {isChecked} = this.state;
            if(isChecked || !backUrl){
            res= await services.apiCall.requestApi('/BusEntidadeEstatuto/Create', data, 'post')
            }
            if (res) {
                this.setState({
                    isChecked: false,
                })
               
            }
            if (backUrl ) {
                this.props.history.push({
                    pathname: '/entity_rule_list',
                    state:{topBarMenu : this.props.topBarMenuOption}
                })
            }
        } catch (error) {
            this.setState({error})
        }

    }

    render() {
        //console.log("state",this.state)
        if(this.state.error){
            throw this.state.error
        }
        return (
            <div className="dashboard">
                {
                    // (this.props.id && this.props.id.location && this.props.id.location.state && this.props.id.location.state.entidade_id) ?
                        this.state.id ?
                        <FormNavbar to={'/entity_rule_list'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Editar Regra da Entidade" />
                        :
                        <FormNavbar to={'/entity_rule_list'} topBarMenu={this.props.topBarMenuOption} handleSubmit={(e, url) => this.handleSubmit(e, url)} type='auditing' headName="Criar nova regra de entidade" />
                }
                <div className="full-container edit-ward">
                    <FormleftNev InputFieldsAll={this.props.InputFieldsAll} />
                    <div className="right-section">

                        <div className="row top-serch">
                            {
                                this.createInputFields()
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default withRouter(EntityRuleFormComponent);